import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { AlertPadelService } from '../../Services/alert.service';

@Component({
  selector: 'basic-alert',
  templateUrl: './basic-alert.component.html',
  styleUrl: './basic-alert.component.scss',
  standalone: true,
  imports: [ToastModule, ButtonModule, RippleModule],
  providers: [MessageService],
})
export class BasicAlertComponent implements OnInit, OnDestroy {
  @Input() toastKey: string = 'br';
  private subscription: Subscription = new Subscription();

  constructor(
    private messageService: MessageService,
    private alertService: AlertPadelService
  ) {}

  ngOnInit() {
    // Subscribe to the alert service to listen for global alert events
    this.subscription = this.alertService.alertEvent$.subscribe((data) => {
      this.messageService.add({
        severity: data.severity,
        summary: data.summary,
        detail: data.detail,
        key: data.key || this.toastKey,
        life: data.life || 3000,
      });
    });
  }

  ngOnDestroy() {
    // Unsubscribe to prevent memory leaks
    this.subscription.unsubscribe();
  }
}

// sample usage
// import { Component } from '@angular/core';
// import { AlertService } from './alert.service';

// @Component({
//   selector: 'app-root',
//   templateUrl: './app.component.html',
// })
// export class AppComponent {
//   constructor(private alertService: AlertService) {}

//   showAlert() {
//     this.alertService.showAlert({
//       severity: 'error',
//       summary: 'Error!',
//       detail: 'Something went wrong.',
//       life: 5000,
//     });
//   }
// }
